import React from "react";
import { BsFillStarFill } from "react-icons/bs";
import { REVIEW_STATS, SOCIAL } from "../seo/site";

/** Stars + "4.9 · 3,500+ reviews" in one place, fed by src/seo/site.js. */
const TrustBadge = ({ variant = "dark", link = true, label }) => (
  <div className={`trust-badge trust-badge--${variant}`}>
    <span className="trust-badge__stars" role="img" aria-label={`Rated ${REVIEW_STATS.rating} out of 5`}>
      <BsFillStarFill /><BsFillStarFill /><BsFillStarFill /><BsFillStarFill /><BsFillStarFill />
    </span>
    <span className="trust-badge__text">
      {label || `${REVIEW_STATS.rating} · ${REVIEW_STATS.countLabel} reviews`}
    </span>
    {link && (
      <a href={SOCIAL.tripadvisor} target="_blank" rel="noopener noreferrer" className="trust-badge__link">
        on TripAdvisor
      </a>
    )}
  </div>
);

export default TrustBadge;
